var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-authorizations',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var allowed = ref.allowed;
return [_c('div',{staticClass:"gap-4 grid grid-flow-1 sm:grid-cols-2 md:grid-cols-3"},_vm._l((_vm.authorizedItems(allowed)),function(item,i){return _c('partner-item',_vm._b({key:("item-" + i)},'partner-item',item,false))}),1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }